import { useEffect, useState } from "react";

const TICK_MS = 1000;
const CEILING = 90;
const EASING = 0.03;

const nextProgress = (progress: number): number =>
  progress < CEILING ? Math.round(progress + (CEILING - progress) * EASING) + 1 : progress;

export const useSimulatedAggregationProgress = (): number => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setProgress(nextProgress), TICK_MS);
    return () => clearInterval(timer);
  }, []);

  return progress;
};
